<template>
  <div id="login" :class="`home-bg-${currentTheme}`" v-loading="ssoLoading">
    <div class="login-wrapper flex justify-around items-center" :class="`${currentTheme}Bg`">
      <div class="login-left" :class="`login-l-${currentTheme}`"></div>
      <div class="login-panel" v-if="!showQrLogin">
        <div class="flex justify-start items-center pb-20px pt-20px">
          <img class="w-40px" :src="iconUrl" alt="" />
          <h4 class="pl-20px main-color text-22px font-bold">{{ title }}</h4>
        </div>
        <div class="flex mb-20px relative" v-if="isShowTenantInput">
          <el-input
            prefix-icon="el-icon-office-building"
            v-model.trim="tenant.name"
            placeholder="请输入租户名"
            @change="checkTenantValid"
            clearable
          ></el-input>
          <i
            class="icon-check el-icon-success absolute text-green-500"
            v-if="tenantIconStatus === 'right'"
          ></i>
          <i
            class="icon-check el-icon-error absolute text-red-500"
            v-if="tenantIconStatus === 'wrong'"
          ></i>
        </div>

        <el-form ref="loginForm" :model="loginForm" :rules="rules">
          <el-form-item prop="userNameOrEmailAddress">
            <el-input
              prefix-icon="el-icon-user"
              v-model.trim="loginForm.userNameOrEmailAddress"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              v-model.trim="loginForm.password"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="submit"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="validateCode" v-if="moduleConfig.needValidateCode">
            <div class="flex justify-between items-center">
              <el-input
                v-model.trim="loginForm.validateCode"
                placeholder="请输入验证码"
                @keyup.enter.native="submit"
              >
              </el-input>
              <img
                :src="validateImg"
                class="h-36px cursor-pointer"
                alt="验证码"
                @click="getValidateImg()"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="w-full" type="primary" size="small" @click="submit" :loading="loading"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
        <!-- 添加企业微信扫码登录入口,用模块config的qywxQrcodeLoginShow控制显示 -->
        <p
          class="text-12px text-blue-700 cursor-pointer text-right"
          v-if="moduleConfig.qywxQrcodeLoginShow"
          @click="switchToQrcodeOrUserPwd('qrcode')"
        >
          企业微信扫码登录
        </p>
      </div>
      <div v-else>
        <qrcode @qywxLogin="qywxLogin"></qrcode>
        <p
          class="text-12px text-blue-700 cursor-pointer text-right pt-10px"
          @click="switchToQrcodeOrUserPwd('userpwd')"
        >
          使用账号登陆
        </p>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { EafLoginApi } from '@wiz-api/auth-server'
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'
// import { SuperagentApi } from '@wiz-core/core'
import { v4 as uuidv4 } from 'uuid'
import SuperagentApi from '@/assets/js/superagentApi'
import Qrcode from '../components/Qrcode'

const eafTenantApi = new EafTenantApi()
const eafLoginApi = new EafLoginApi()
const Auth = Wiz.AuthHooks
const authServer = Wiz.GetModuleServer('auth-server')
const superagentApi = new SuperagentApi({ baseUrl: authServer })

export default {
  components: { Qrcode },
  data() {
    return {
      ssoLoading: false,
      tenantConfig: null,
      title: null,
      iconUrl: null,
      logoUrl: require('../assets/images/pr.png'),
      tenantFromUrl: '',
      isShowTenantInput: true,
      tenant: {
        id: '',
        name: '',
      },
      tenantIconStatus: 'hide', // 默认隐藏不显示：hide 租户校验错误：wrong 租户校验正确：right
      showQrLogin: false,
      validateImg: '',
      validateId: '',
      loginForm: {
        userNameOrEmailAddress: '',
        password: '',
        validateCode: '',
      },
      rules: {
        userNameOrEmailAddress: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      loading: false,
    }
  },
  computed: {
    currentTheme() {
      const currentTheme = this.$store.getters['System/currentTheme']
      return currentTheme === 'darkBlue' ? 'light' : currentTheme
    },
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
    moduleConfig() {
      return Wiz.GetModuleConfig('auth-login')
    },
    globalConfig() {
      return Wiz.globalSettings.globalConfig
    },
    fileServerPrefix() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  methods: {
    /**
     * 切换登录方式
     * @param {*} type qrcode:切换扫码登录  / userpwd：切换账密登录
     */
    async switchToQrcodeOrUserPwd(type) {
      if (type === 'qrcode') {
        // 获取配置租户信息
        this.showQrLogin = true
        if (this.moduleConfig.qywxTenantName) {
          this.tenant.name = this.moduleConfig.qywxTenantName
          const { err, res } = await this.getTenantByName(this.tenant.name)
          if (!err) {
            this.tenant.id = res.id
          }
        }
      } else if (type === 'userpwd') {
        // 是否还原租户信息
        this.tenant = this.$options.data().tenant
        this.showQrLogin = false
      }
    },
    async qywxLogin(code) {
      const formData = new URLSearchParams()
      const params = {
        grant_type: 'qy_wechat_qr_code',
        client_id: 'Portal_Js',
        scope:
          this.moduleConfig.loginScope ||
          'AuthServer Portal openid profile address email phone role WizResource',
        code,
      }
      _.forIn(params, (v, k) => {
        formData.append(k, v)
      })
      const [err, res] = await superagentApi.post('/connect/token', {
        data: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Wiz-Tenant-Id': this.tenant.id,
          'Accept-Language': this.currentLang,
        },
      })
      if (err) {
        this.$message.error(`请求错误:${err.error_description}`)
      } else {
        await this.getUserInfo(res.access_token)
      }
    },
    submit() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          if (!this.tenant.name) {
            // 运营商登录
            await this.loginFn()
          } else {
            // 接口未验证完
            if (this.tenantIconStatus === 'hide') {
              this.$message.info('请等待租户校验结果完成再点击登录')
            }
            // 租户错误或不存在
            if (this.tenantIconStatus === 'wrong') {
              this.$message.warning(`未找到租户${this.tenant.name},请检查`)
            }
            // 租户登录
            if (this.tenantIconStatus === 'right') {
              await this.loginFn()
            }
          }
        }
      })
    },
    async loginFn() {
      this.loading = true
      const publicKey = await this.getRsaKey()
      const rsa = new JSEncrypt()
      rsa.setPublicKey(publicKey)
      const encriptPwd = rsa.encrypt(this.loginForm.password)
      const formData = new URLSearchParams()
      const params = {
        grant_type: 'password',
        client_id: 'Portal_Js',
        scope:
          this.moduleConfig.loginScope ||
          'AuthServer Portal openid profile address email phone role WizResource',
        username: this.loginForm.userNameOrEmailAddress,
        password: encriptPwd,
      }
      if (this.moduleConfig.needValidateCode) {
        _.assign(params, {
          validate_id: this.validateId,
          validate_code: this.loginForm.validateCode,
        })
      }
      _.forIn(params, (v, k) => {
        formData.append(k, v)
      })
      const [err, res] = await superagentApi.post('/connect/token', {
        data: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Wiz-Tenant-Id': this.tenant.id,
          'Accept-Language': this.currentLang,
        },
      })
      this.loading = false
      if (err) {
        this.$message.error(`请求错误:${err.error_description}`)
        // 如果无需验证码，则不需要访问二维码接口
        if (this.moduleConfig.needValidateCode) {
          this.getValidateImg()
        }
      } else {
        await this.getUserInfo(res.access_token)
      }
    },
    async getTenantByName(name) {
      const [err, res] = await eafTenantApi.getPublishByTenantName({ name })
      // 获取租户配置
      if (res?.detail?.jsonConfig) {
        this.tenantConfig = JSON.parse(res.detail.jsonConfig)
      }
      return { err, res }
    },
    async checkTenantValid(name) {
      // 重置，否则从right-->wrong租户id还保留上次正常的值导致bug
      this.tenant.id = ''
      this.tenantIconStatus = 'hide'
      if (_.isEmpty(name)) {
        this.tenantIconStatus = 'hide'
        document.querySelector("link[rel='icon']").href = require('../assets/images/favicon.png')
        document.title = 'Wiz SaaS'
        this.iconUrl = require('../assets/images/favicon.png')
        this.title = 'Wiz SaaS'
        return
      }
      const { err, res } = await this.getTenantByName(name)
      if (!err) {
        this.tenant.id = res.id
        this.tenantIconStatus = 'right'
        this.setIconName(res)
      } else {
        this.tenantIconStatus = 'wrong'
      }
    },
    async getUserInfo(token) {
      const [err, res] = await superagentApi.get('/connect/userinfo', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Accept-Language': this.currentLang,
        },
      })
      if (err) {
        this.$message.error(`请求错误:${err.error_description}`)
      } else {
        Wiz.AuthHooks.clearUserStorageInfo(res.sub)
        await Auth.SetUserInfo(
          {
            access_token: token,
            profile: { tenantName: this.tenant.name, tenantid: this.tenant.id, ...res },
            tenantConfig: this.tenantConfig,
          },
          this.$route.query.redirectUrl
        )
        Wiz.AuthHooks.setProjectInfo({
          logoUrl: this.logoUrl,
          iconUrl: this.iconUrl,
          title: this.title,
        })
        // Wiz.AuthHooks.initRedirect(this.tenant.name)
      }
    },
    setIconName(res) {
      // const baseUrl = Wiz.globalSettings.layout.config.iconUrl
      document.querySelector("link[rel='icon']").href =
        res.detail && res.detail.icon
          ? `${this.fileServerPrefix}${res.detail.icon}`
          : require('../assets/images/favicon.png')
      this.iconUrl =
        res.detail && res.detail.icon
          ? `${this.fileServerPrefix}${res.detail.icon}`
          : require('../assets/images/favicon.png')
      document.title = res.detail ? res.detail.name : 'Wiz Saas'
      this.title = res.detail ? res.detail.name : 'Wiz Saas'
      this.logoUrl =
        res.detail && res.detail.logo
          ? `${this.fileServerPrefix}${res.detail.logo}`
          : require('../assets/images/pr.png')
    },
    async getValidateImg() {
      this.validateId = uuidv4()
      const [err, res] = await eafLoginApi.getValidateCode({ codeId: this.validateId })
      if (res) {
        this.validateImg = `data:image/png;base64,${res.imageBase64}`
      }
    },
    async getRsaKey() {
      const [err, res] = await eafLoginApi.rSAEncrypt()
      if (err) return ''
      return res.publicKey
    },
  },
  async created() {
    this.title = this.moduleConfig.loginTitle || 'Wiz SaaS'
    this.iconUrl = this.moduleConfig.loginLogo || require('../assets/images/favicon.png')
    if (this.moduleConfig.needValidateCode) {
      this.getValidateImg()
      _.assign(this.rules, {
        validateCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      })
    }
    /**
     * 处理：单点登录
     */
    if (this.$route.query.account && this.$route.query.account !== 'host') {
      this.ssoLoading = true
      if (this.globalConfig.ssoTenantName) {
        this.tenant.name = this.globalConfig.ssoTenantName
        document.querySelector("link[rel='icon']").href = this.iconUrl
        const { err, res } = await this.getTenantByName(this.tenant.name)
        if (!err) {
          this.tenant.id = res.id
          this.tenantIconStatus = 'right'
          this.setIconName(res)
        } else {
          this.tenantIconStatus = 'wrong'
        }
      } else {
        this.ssoLoading = false
        this.$message.error('请配置租户名称!')
        return
      }
      const params = {
        scope: 'AuthServer Portal openid profile role email address phone',
        client_id: 'Portal_Js',
        grant_type: 'loginby_username',
        is_sso_login: true,
        username: this.$route.query.account,
      }
      const formData = new URLSearchParams()
      _.forIn(params, (v, k) => {
        formData.append(k, v)
      })
      const [err, res] = await superagentApi.post('/connect/token', {
        data: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Wiz-Tenant-Id': this.tenant.id,
          'Accept-Language': this.currentLang,
        },
      })
      if (err) {
        this.$message.error(`请求错误:${err.error_description}`)
      } else {
        await this.getUserInfo(res.access_token)
      }
      this.ssoLoading = true
      return
    }
    /**
     * 处理：1.手动配置租户名和租户id,隐藏租户输入框；
     * 2.开放运营商登录，添加query参数为account=host
     */
    if (this.globalConfig.tenantName) {
      this.isShowTenantInput = false
      this.tenant.name = this.globalConfig.tenantName
      document.querySelector("link[rel='icon']").href = this.iconUrl
      const { err, res } = await this.getTenantByName(this.tenant.name)
      if (!err) {
        this.tenant.id = res.id
        this.tenantIconStatus = 'right'
        this.setIconName(res)
      } else {
        this.tenantIconStatus = 'wrong'
      }

      const account = this.$route.query.account
      if (account === 'host') {
        this.tenant.name = ''
        this.tenant.id = ''
      }
    }

    // 处理：url带租户名隐藏租户输入框
    this.tenantFromUrl = this.$route.params.tenant || ''
    if (this.tenantFromUrl) {
      this.tenant.name = this.tenantFromUrl
      const { err, res } = await this.getTenantByName(this.tenantFromUrl)
      if (!err) {
        this.tenant.id = res.id
        this.isShowTenantInput = false
        this.tenantIconStatus = 'right'
        this.setIconName(res)
      } else {
        this.isShowTenantInput = true
        this.tenantIconStatus = 'wrong'
      }
    }
  },
  mounted() {
    let currentTheme = ''
    const themeConfig = Wiz.globalSettings.layout.config
    if (themeConfig) {
      currentTheme = !_.isNil(themeConfig.defaultTheme) ? themeConfig.defaultTheme : ''
    }
    if (this.currentTheme) {
      // 有缓存，读取缓存主题
      currentTheme = this.currentTheme
    }
    currentTheme = currentTheme || 'light'
    this.$store.dispatch('System/currentTheme', currentTheme)
    document.getElementsByTagName('body')[0].className = currentTheme
  },
}
</script>

<style lang="scss" scoped>
#login {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}

.home-bg-dark {
  background-image: url('../../../../assets/images/home-bg-dark.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.home-bg-light {
  background-image: url('../../../../assets/images/home-bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.home-bg-red {
  background-image: url('../../../../assets/images/home-bg-red.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.login-wrapper {
  position: relative;
  top: 50%;
  left: 50%;
  width: 80%;
  height: 80%;
  // background: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  transform: translate(-50%, -50%);

  .login-l-dark {
    background-image: url('../../../../assets/images/login-l-dark.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .login-l-light {
    background-image: url('../../../../assets/images/login-l.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .login-l-red {
    background-image: url('../../../../assets/images/login-l-red.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

.icon-check {
  top: 10px;
  right: -20px;
}

.login-left {
  width: 396px;
  height: 438px;
}

.login-panel {
  padding: 40px;
  width: 400px;

  .main-color {
    color: var(--systemMainColor);
  }

  ::v-deep .el-input {
    max-width: 100%;
  }
}

.flex-between-mid {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.w-200px {
  width: 200px;
}

.darkBg {
  background: rgba(255, 255, 255, 0.1);
}

.lightBg {
  background: rgba(255, 255, 255, 0.5);
}

.redBg {
  background: rgba(255, 255, 255, 0.5);
}

@media (max-width: 1000px) {
  .login-left {
    display: none;
  }

  .login-panel {
    width: 80%;
  }

  .login-wrapper {
    height: 70%;
  }
}
</style>
